export default __webpack_public_path__ + "static/media/circle-arrow.9eed568c.svg";